module.exports = __webpack_public_path__ + "static/media/signature-hide.7cde1c64.png";